import { get } from 'lodash';

function getProviderLatLng(provider, fallback = {}) {
  return {
    lat: get(provider, 'lat', get(provider, 'addresses[0].lat_lng[0]', fallback.lat)),
    lng: get(provider, 'lon', get(provider, 'addresses[0].lat_lng[1]', fallback.lng)),
  };
}

export default getProviderLatLng;



// WEBPACK FOOTER //
// ./public/js/utils/getProviderLatLng.js